import * as React from 'react';

// Utils
import { useFlexLaneContractWait } from '@src/hooks';

// The sidebar, the confirm pane and the success overlay each need to know whether the FlexLane contract step
// has answered, and they sit at different depths of the checkout tree. Calling the hook in each of them gives
// each its own give-up timer, and a browser-back during the wait remounts only the route-scoped ones: the
// success overlay then lands on top of a loader that is still spinning. One instance above all three is what
// stops them disagreeing (lanes-planes/backend#15086).
const FlexLaneContractWaitContext = React.createContext(false);

export const FlexLaneContractWaitProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const awaitingFlexLaneContract = useFlexLaneContractWait();

  return (
    <FlexLaneContractWaitContext.Provider value={awaitingFlexLaneContract}>
      {children}
    </FlexLaneContractWaitContext.Provider>
  );
};

export const useAwaitingFlexLaneContract = () => React.useContext(FlexLaneContractWaitContext);
